import cn from "classnames";
import Select from "components/shared/select";
import { RouteOptions } from "helpers/map";
import React from "react";
import { CustomScroll } from "react-custom-scroll";
import { list } from "sources/books/routeTemplates";

const templateConfig = {
    placeholder: "Построить маршрут на основе шаблона",
    inputProps: { name: "status" },
    url: list,
    propName: "name",
    menuPlacement: "top",
    menuPortalTarget: document.body,
};

const MapSettings = (props) => {
    const {
        defaultRouteOptions,
        routeOptions,
        refreshSegmentRoutes,
        updateSettings,
        modal,
        routeTemplateId,
        handleRouteTemplate,
        routeOptionsOpened,
    } = props;
    const optionsCname = cn("map-panels__option-items", {
        "map-panels__option-items--visible": routeOptionsOpened,
    });
    const expandCname = cn("map-panels__collapse-btn", {
        "map-panels__collapse-btn--top": !routeOptionsOpened,
        "map-panels__collapse-btn--bottom": routeOptionsOpened,
    });

    const renderTemplateSelect = () => {
        const props = {
            ...templateConfig,
            onChange: ({ value, option }) => {
                if (!value) {
                    if (confirm("Удалить шаблон?")) {
                        updateSettings({ routeTemplateId: value });
                        handleRouteTemplate();
                    }
                } else {
                    if (confirm(`Использовать шаблон "${option.name}"?`)) {
                        updateSettings({ routeTemplateId: value });
                        handleRouteTemplate(option.supportPoints);
                    }
                }
            },
            value: routeTemplateId,
        };
        return (
            <div className="map-panels__footer--select">
                <Select {...props} />
            </div>
        );
    };

    return (
        <CustomScroll heightRelativeToParent="calc(100% - 58px)">
            <div className="map-panels__options">
                <div className={optionsCname}>
                    <RouteOptions
                        defaultRouteOptions={defaultRouteOptions}
                        routeOptions={routeOptions}
                        refreshSegmentRoutes={refreshSegmentRoutes}
                        updateSettings={updateSettings}
                        modal={modal}
                    />

                    {renderTemplateSelect()}
                </div>
                <div
                    className="map-panels__option-toggle"
                    onClick={() => updateSettings({ routeOptionsOpened: !routeOptionsOpened })}
                >
                    Дополнительные опции
                    <div className={expandCname}></div>
                </div>
            </div>
        </CustomScroll>
    );
};

export default MapSettings;
